import Image from "next/image";

export default function MacWindowMockup() {
  return (
    <div className="w-full max-w-[1100px] mx-auto rounded-[.75rem] md:rounded-3xl lg:rounded-4xl overflow-hidden mockup-glow border border-[#dedee0]">
      {/* Title bar */}
      {/* <div className="flex items-center gap-1.5 sm:gap-2 bg-white/80 backdrop-blur-sm px-2.5 py-2 sm:px-4 sm:py-3 border-b border-black/[0.06]">
        <div className="flex gap-[5px] sm:gap-[6px]">
          <span className="w-[8px] h-[8px] sm:w-[11px] sm:h-[11px] rounded-full bg-[#FF5F57]" />
          <span className="w-[8px] h-[8px] sm:w-[11px] sm:h-[11px] rounded-full bg-[#FEBC2E]" />
          <span className="w-[8px] h-[8px] sm:w-[11px] sm:h-[11px] rounded-full bg-[#28C840]" />
        </div>
        <div className="flex-1 flex justify-center">
          <div className="bg-dark-teal/[0.04] text-dark-teal/40 text-[10px] sm:text-[12px] font-medium px-2.5 py-[2px] sm:px-3.5 sm:py-[3px] rounded-md tracking-wide">
            app.getverify.cl
          </div>
        </div>
        <div className="w-[36px] sm:w-[51px]" />
      </div> */}

      {/* Body */}
      {/* Phones get a zoomed crop of the top-left (sidebar + KPI row) instead of
          an illegible full-width thumbnail; from `sm` up the whole panel shows. */}
      <div className="aspect-[4/3] overflow-hidden bg-[#F8F9FC] sm:aspect-auto">
        <Image
          src="/mockup.webp"
          alt="Panel de Verify con documentos por vencer, en revisión y tasa de cumplimiento"
          width={2400}
          height={1394}
          priority
          sizes="(max-width: 640px) 165vw, 1100px"
          className="block h-auto w-[165%] max-w-none sm:w-full"
        />
      </div>
    </div>
  );
}
